import { PureComponent, ReactNode } from 'react';
import { AntTooltip } from '../../../../common/AntTooltip';

interface Props {
    tooth: string;
    sixthSurfaceName: string;
    isSixthSurfaceSelected: boolean;
    selectSurface: (teeth: string, surface: number) => void;
    isForLowerTeeth?: boolean;
}

class SixthSurface extends PureComponent<Props> {
    render(): ReactNode {
        const {
            tooth,
            sixthSurfaceName,
            isSixthSurfaceSelected,
            selectSurface,
            isForLowerTeeth,
        } = this.props;

        return (
            <AntTooltip content={sixthSurfaceName} placement="right" mouseEnterDelay={0.5}>
                <svg
                    className="max-w-40 max-h-18 cursor-pointer my-4"
                    viewBox="0 0 37 18"
                    xmlns="http://www.w3.org/2000/svg"
                    style={isForLowerTeeth ? { transform: 'rotate(180deg)' } : undefined}
                >
                    <path
                        d="M35.0519 17C35.5897 17 36.0284 16.6016 35.9986 16.1115C35.7599 12.1919 33.949 8.47677 30.8925 5.68629C27.6058 2.68571 23.1481 1 18.5 1C13.8519 1 9.39423 2.68571 6.10754 5.68629C3.051 8.47677 1.24006 12.1919 1.00144 16.1115C0.971597 16.6016 1.41033 17 1.94806 17H8.76357C9.30129 17 9.73161 16.6008 9.79122 16.1129C10.0106 14.3175 10.8911 12.6328 12.3038 11.3431C13.9471 9.84285 16.176 9 18.5 9C20.824 9 23.0529 9.84285 24.6962 11.3431C26.1089 12.6328 26.9894 14.3175 27.2088 16.1129C27.2684 16.6008 27.6987 17 28.2364 17H35.0519Z"
                        fill={isSixthSurfaceSelected ? '#D1EDE1' : '#F4F4F4'}
                        stroke={isSixthSurfaceSelected ? '#19A66A' : '#BABABA'}
                        stroke-width="1.28571"
                        onClick={() => selectSurface(tooth, 6)}
                    />
                </svg>
            </AntTooltip>
        );
    }
}

export default SixthSurface;
